import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CheckCircleIcon } from 'lucide-react';
export function AudienceSection() {
  const forWhom = [{
    title: 'Profesores de Educación Física',
    desc: 'Que quieren dejar de improvisar y justificar cada ejercicio con criterio.'
  }, {
    title: 'Entrenadores Personales',
    desc: 'Que buscan respaldar sus decisiones con una base técnica sólida.'
  }, {
    title: 'Instructores de Musculación',
    desc: 'Que quieren corregir errores con seguridad y aumentar la confianza de sus alumnos.'
  }];
  return <section className="py-10 relative overflow-hidden bg-background" data-id="element-1">
      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-2">
        <FadeIn className="text-center mb-10" data-id="element-3">
          <h2 className="text-4xl md:text-5xl font-black mb-6 text-gray-900" data-id="element-4">
            ¿Es este pack para vos?
          </h2>
          <p className="text-xl text-gray-500 max-w-2xl mx-auto" data-id="element-5">
            Diseñado específicamente para quienes se toman en serio su
            profesión.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-4" data-id="element-6">
          {forWhom.map((item, index) => <FadeIn key={index} delay={0.2 + index * 0.1} direction="up" data-id="element-7">
              <div className="bg-card border border-green-500/20 rounded-xl p-5 h-full relative overflow-hidden" data-id="element-8">
                <div className="absolute top-0 right-0 w-48 h-48 bg-green-500/5 rounded-full blur-3xl pointer-events-none" data-id="element-9" />
                <div className="flex items-center gap-3 mb-2" data-id="element-10">
                  <div className="w-10 h-10 rounded-lg bg-green-500/10 flex items-center justify-center shrink-0" data-id="element-11">
                    <CheckCircleIcon className="w-5 h-5 text-green-500" data-id="element-12" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900" data-id="element-13">
                    {item.title}
                  </h3>
                </div>
                <p className="text-gray-500 text-sm" data-id="element-14">{item.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}